import React from 'react'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { ContentWithOffset } from '../../components/scharedStyles/style'
import ScheduleExport from './ScheduleExport'
import ScheduleFilters from './ScheduleFilters'
import ScheduleList from './ScheduleList'
import { PageLayout } from './style'
import { useScheduleEffects } from './hooks'

dayjs.extend(customParseFormat)

const Schedule = () => {
    useScheduleEffects()

    return (
        <>
            <ScheduleExport />

            <ContentWithOffset>
                <PageLayout>
                    <ScheduleFilters />
                    <ScheduleList />
                </PageLayout>
            </ContentWithOffset>
        </>
    )
}

export default Schedule
